const LS = window.localStorage;
const STORAGE_NAME = 'cmdc_ui';

export function getLS() {
  try {
    const data = JSON.parse(LS.getItem(STORAGE_NAME) || '{}');
    return data;
  } catch (e) {
    console.error(e);
  }
}

export function setLS<T>(data: T) {
  const currentData = getLS();
  LS.setItem(STORAGE_NAME, JSON.stringify({ ...currentData, ...data }));
}

export function clearLS() {
  LS.removeItem(STORAGE_NAME);
}

export function clearLSKeys(...key: string[]) {
  const currentData = getLS();
  key.forEach(k => delete currentData[k]);
  LS.setItem(STORAGE_NAME, JSON.stringify(currentData));
}

export function setLSKeyValue<T>(store: string, key: string, value: T) {
  const currentData = getLS() || {};

  if (!currentData[store]) {
    currentData[store] = {};
  }

  currentData[store] = {
    ...currentData[store],
    [key]: value,
  };

  LS.setItem(STORAGE_NAME, JSON.stringify(currentData));
}
